import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { updateActualElement, setActiveElement } from '@/store/actions'

/** Components */
import Opacity from '@/components/Opacity'
import Border from '@/components/editors/Border'
import BoxShadow from '@/components/editors/BoxShadow'
import BorderRadius from '@/components/editors/BorderRadius'
import UploadImage from '@/components/UploadImage'
import GradientBuilder from '@/components/gradientBuilder/GradientBuilder'
import ColorPicker from '@/components/ColorPicker'
import FontLink from '../../../../../../components/editors/FontLink/index'

class ShapeContent extends Component {
  state = {
    type: 'settings'
  }

  save = element => {
    const { id, id_page: pageID } = element
    const { updateActualElement, user: { accessToken } } = this.props

    updateActualElement({
      id,
      pageID,
      element,
      accessToken
    })
  }

  handleStyles = style => {
    const { element } = this.props

    element.content.styles = {
      ...element.content.styles,
      ...style
    }
    this.save(element)
  }

  handleContent = content => {
    const { element } = this.props

    element.content.content = {
      ...element.content.content,
      ...content
    }

    this.save(element)
  }

  handleAttributes = attribute => {
    const { element } = this.props

    element.content.attributes = {
      ...element.content.attributes,
      ...attribute
    }
    this.save(element)
  }


  handleEmbedURL = value => {
    this.handleContent({
      embedURL: value,
      embedDocument: ''
    })
  }

  handleEmbedDocument = value => {
    this.handleContent({
      embedURL: '',
      embedDocument: value
    })
  }

  handleImageSended = src => this.handleStyles({
    backgroundImage: `url(${src})`,
    backgroundSize: '100% 100%'
  })

  handleBorder = ({ type, size, color }) => this.handleStyles({
    borderStyle: type,
    borderWidth: `${size}px`,
    borderColor: color
  })

  handleShadow = shadow => this.handleStyles({
    boxShadow: `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}`
  })

  handleLink = link => {
    const { element } = this.props
    element.content.link = link
    this.save(element)
  }

  render() {
    const { translation, type: elementType, element } = this.props

    const {
      borderWidth,
      borderStyle,
      borderColor,
      opacity,
      fill,
      backgroundColor,
      backgroundImage,
      boxShadow,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
    } = element.content.styles

    const { attributes, link } = element.content


    const typeBackground = !!fill ? 'fill' : 'backgroundColor'
    const backgroundGradient = backgroundImage
    const gradient = attributes.gradient.map(g => ({
      color: g.color,
      pos: +g.pos
    }))

    const showOptions = /square|circle/.test(elementType)

    return (
      <div className={'ba-pd-r-1 ba-pd-b-2'}>
        <hr className="ba-hr" />

        {showOptions && (
          <Fragment>
            <p className='ba-font ba-mg-t-1'>{translation('general-border')}</p>
            <Border
              type={borderStyle}
              size={borderWidth}
              color={borderColor}
              onChange={this.handleBorder}
            />
          </Fragment>
        )}

        <p className='ba-font ba-mg-t-1'>{translation('general-transparency')}</p>
        <Opacity
          opacity={opacity}
          onChange={value => this.handleStyles({ opacity: value })}
        />

        <hr className="ba-hr" />

        <p className='ba-font ba-mg-t-1'>{translation('general-shadow')}</p>
        <BoxShadow
          shadow={boxShadow}
          onChange={this.handleShadow}
        />

        <hr className="ba-hr" />

        <p className='ba-font ba-mg-t-1'>{translation('general-border-radius')}</p>
        <BorderRadius
          topLeft={borderTopLeftRadius}
          topRight={borderTopRightRadius}
          bottomLeft={borderBottomLeftRadius}
          bottomRight={borderBottomRightRadius}
          onChange={this.handleStyles}
        />

        <hr className="ba-hr" />

        {showOptions && (
          <Fragment>
            <p className='ba-font ba-mg-t-1'>{translation('general-background-image')}</p>
            <UploadImage
              text={translation('image-select')}
              onImageSended={this.handleImageSended}
            />
          </Fragment>
        )}

        <p className='ba-font ba-mg-t-1'>{translation('general-background-color')}</p>
        <ColorPicker
          color={typeBackground === 'fill' ? fill : backgroundColor}
          onChange={value => this.handleStyles({
            [typeBackground]: value.hex,
            backgroundImage: null
          })}
        />

        {showOptions && (
          <Fragment>
            <p className='ba-font ba-mg-t-1'>{translation('general-background-gradient')}</p>
            <GradientBuilder
              palette={
                gradient.length
                  ? gradient
                  : [
                    {
                      color: '#fff',
                      pos: 0
                    },
                    {
                      color: '#000',
                      pos: 1
                    }
                  ]
              }
              backgroundGradient={backgroundGradient}
              onPaletteChange={palet => this.handleAttributes({ gradient: palet })}
              onGradientChange={gradient => this.handleStyles({ backgroundImage: gradient })
              }
            />
          </Fragment>
        )}

        <hr className="ba-hr" />

        <FontLink link={link} onChangeLink={this.handleLink} />

      </div>
    )
  }
}

const mapStateProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default connect(mapStateProps,
  {
    updateActualElement,
    setActiveElement
  }
)(ShapeContent)


// WEBPACK FOOTER //
// ./src/pages/Editor/components/ContentEditor/editors/ShapeContent/index.js